/**
 * הודעת סטטוס בפאנל — TASKS 6.2 · DESIGN.md 6.4 (פרופיל תנועה קבוע לפאנל).
 *
 * ⚠️ **סטייה מודעת מ-DESIGN.md 6.4:** שם מתואר "toast" — הודעה צפה שנכנסת
 *    מ-inline-end ויוצאת אוטומטית אחרי 4 שניות. הפאנל **כבר** משתמש בדפוס
 *    קבוע ועקבי בכל המסכים: הודעת `role="status"` **inline**, לא צפה
 *    (`CustomerDetailPage`, `QuoteDetailPage`, `WhatsAppSendButton`).
 *    בניית מערכת toast צפה חדשה (portal, מיקום, ערימה) היא שינוי ארכיטקטורה
 *    ולא רק תנועה — מחוץ להיקף "פרופיל תנועה קבוע" של 6.2. הרכיב הזה נותן
 *    לדפוס ה-inline הקיים את התנועה שהמפרט מבקש (כניסה 200ms), בלי לשנות
 *    את מבנה ה-DOM או ה-API של שום מסך.
 *
 * ⛔ בלי כניסות מדורגות, בלי hover lift — "מהירות = כבוד למשתמש" (6.4).
 */
import { motion } from 'motion/react';
import type { ReactNode } from 'react';

interface StatusMessageProps {
  children: ReactNode;
  className?: string;
}

export function StatusMessage({ children, className }: StatusMessageProps) {
  return (
    <motion.p
      role="status"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2 }}
      className={className}
    >
      {children}
    </motion.p>
  );
}
